import { connect } from 'react-redux';
import EmailValidator from 'email-validator';

import { getCompositionDraft, getCustomText } from 'app/modules';
import InputValidationComposition from 'presentation/selfService/InputValidationComposition';
import userEvents from 'events/user';
import uiEvents from 'events/ui';

function validateInput(currentInput) {
  return EmailValidator.validate(currentInput);
}

export const mapStateToProps = (state, props) => {
  let currentInput = getCompositionDraft(state);
  let compositionText = getCustomText(state).composition;

  return {
    ...props,
    canAddAttachments: false,
    compositionDraft: currentInput,
    errorMessage: compositionText.emailError,
    hasContent: /\S+/.test(currentInput),
    prompt: compositionText.emailPrompt,
    shouldAutoFocus: false,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onChange: text => {
      dispatch(uiEvents.updateCompositionDraft(text));
    },
    onSubmit: currentInput => {
      dispatch(uiEvents.updateCompositionDraft(''));
      dispatch(userEvents.updateUser({ email: currentInput }));
    },
    onValidate: currentInput => validateInput(currentInput),
  };
};

const EmailValidationCompositionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InputValidationComposition);

export default EmailValidationCompositionContainer;
